/**
 * Текст ошибки для формы аутентификации.
 *
 * Сервер присылает готовые сообщения на русском (docs/06-api.md), поэтому
 * своих формулировок здесь нет — кроме случая, когда ответа не разобрать
 * (сеть отвалилась, прокси вернул HTML).
 */

import { ApiError } from '@/api/client'
import { strings } from '@/lib/strings'

export function authErrorMessage(error: unknown): string | null {
  if (error === null || error === undefined) {
    return null
  }
  if (error instanceof ApiError && error.message.length > 0) {
    return error.message
  }
  return strings.auth.unknownError
}

/**
 * Текст неудачного входа через провайдера.
 *
 * Здесь, в отличие от остальных ошибок, приходит только код: колбэк провайдера
 * возвращает браузер редиректом, а тело ответа с сообщением сервера в такой
 * схеме передать негде (docs/adr/0008-federated-login.md).
 */
export function oauthErrorMessage(code: string | null): string | null {
  if (code === null || code.length === 0) {
    return null
  }
  return strings.auth.oauthFailed[code] ?? strings.auth.oauthUnknownError
}
